"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findMinExpiration = findMinExpiration;
exports.calcTimeout = calcTimeout;
exports.validateTimeoutValue = validateTimeoutValue;
exports.hasExpirationProperty = exports.isAnyTokenExpired = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var isTokenExpired = function isTokenExpired(token) {
  return token.expiration && new Date(token.expiration) <= new Date();
};

var isAnyTokenExpired = function isAnyTokenExpired(_ref) {
  var refreshToken = _ref.refreshToken,
      tokens = (0, _objectWithoutProperties2.default)(_ref, ["refreshToken"]);
  return Object.values(tokens).some(isTokenExpired);
};

exports.isAnyTokenExpired = isAnyTokenExpired;

var hasExpirationProperty = function hasExpirationProperty(_ref2) {
  var refreshTokens = _ref2.refreshTokens,
      tokens = (0, _objectWithoutProperties2.default)(_ref2, ["refreshTokens"]);
  return Object.values(tokens).some(function (token) {
    return Boolean(token.expiration);
  });
};
/**
 * find token with the lowest expiration value
 */


exports.hasExpirationProperty = hasExpirationProperty;

function findMinExpiration(_ref3) {
  var refreshToken = _ref3.refreshToken,
      tokens = (0, _objectWithoutProperties2.default)(_ref3, ["refreshToken"]);
  var values = Object.values(tokens);
  var minExpiration = values[0].expiration;

  for (var _i = 0; _i < values.length; _i++) {
    var _ref5 = values[_i];
    var expiration = _ref5.expiration;

    if (expiration < minExpiration) {
      minExpiration = expiration;
    }
  }

  return minExpiration;
}
/**
 * calc timeout - when token expires
 * @param  {Number} expiration
 * @param  {Number} requestDurationEstimate
 * @return {Number}
 */


function calcTimeout(expiration) {
  var requestDurationEstimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var timeout = new Date(expiration) - new Date();
  return Math.max(timeout - requestDurationEstimate, 0);
}

function validateTimeoutValue(_ref6) {
  var timeoutValue = _ref6.timeoutValue,
      tokens = _ref6.tokens,
      options = _ref6.options;

  if (timeoutValue === 0) {
    throw new Error("Can't set 0 timeout for refreshing tokens. Check the token 'expiration' propererty.\nTokens: ".concat(JSON.stringify(tokens, null, 2)));
  } else if (timeoutValue < options.minRequiredExpiration) {
    throw new RangeError("Token 'timeoutValue' value is too low. Minimum required value is: ".concat(options.minRequiredExpiration + options.requestDurationEstimate, "ms."));
  }
}